<template>
  <div class="p-4 md:p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
    <!-- Encabezado -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
      <div class="flex items-center space-x-3">
        <div class="h-10 w-1 bg-gradient-to-b from-blue-500 to-indigo-600 rounded-full"></div>
        <div>
          <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">Reporte de Ventas</h1>
          <p class="text-sm text-gray-500 dark:text-gray-400 flex items-center mt-1">
            <Icon icon="mdi:chart-line" class="mr-1" />
            Jean Informatico - Reportes de Ventas
          </p>
        </div>
      </div>
      <button
        @click="volver"
        class="px-4 py-2 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 shadow-sm hover:shadow flex items-center gap-2"
      >
        <Icon icon="mdi:arrow-left" class="text-lg" />
        Volver al panel
      </button>
    </div>

    <!-- Filtros -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-6 mb-6">
      <div class="flex flex-wrap gap-4 items-end">
        <!-- Filtro por Factura -->
        <div class="flex-1 min-w-[180px]">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            N° Factura
          </label>
          <div class="relative">
            <Icon icon="mdi:receipt-text-outline" class="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
            <input
              v-model="filtros.numeroFactura"
              type="text"
              placeholder="Buscar por factura..."
              class="w-full pl-11 pr-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-800 dark:text-white"
              @input="aplicarFiltros"
            />
          </div>
        </div>

        <!-- Filtro por Tipo de Venta -->
        <div class="flex-1 min-w-[180px]">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Tipo de Venta
          </label>
          <select
            v-model="filtros.tipoVenta"
            class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          >
            <option value="todos">Todos</option>
            <option value="contado">Contado</option>
            <option value="credito">Crédito</option>
          </select>
        </div>



        <!-- Filtro por Cliente -->
        <div class="flex-1 min-w-[200px]">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Cliente
          </label>
          <select
            v-model="filtros.idCliente"
            class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          >
            <option value="todos">Todos los clientes</option>
            <option v-for="cliente in clientes" :key="cliente.idCliente" :value="cliente.idCliente">
              {{ cliente.nombreCompleto }}
            </option>
          </select>
        </div>

        <!-- Filtro por Vendedor -->
        <div class="flex-1 min-w-[200px]">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Vendedor
          </label>
          <select
            v-model="filtros.idVendedor"
            class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          >
            <option value="todos">Todos los vendedores</option>
            <option v-for="vendedor in vendedores" :key="vendedor.idVendedor" :value="vendedor.idVendedor">
              {{ vendedor.nombreCompleto }}
            </option>
          </select>
        </div>

        <!-- Filtro por Rango de Fechas -->
        <div class="flex-1 min-w-[180px]">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Desde
          </label>
          <input
            v-model="filtros.fechaDesde"
            type="date"
            class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          />
        </div>

        <div class="flex-1 min-w-[180px]">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Hasta
          </label>
          <input
            v-model="filtros.fechaHasta"
            type="date"
            class="w-full px-4 py-3 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
            @change="aplicarFiltros"
          />
        </div>

        <!-- Botones de acción -->
        <div class="flex gap-2">
          <button
            @click="aplicarFiltros"
            class="px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 font-medium shadow-md hover:shadow-lg flex items-center gap-2"
          >
            <Icon icon="mdi:filter" class="text-lg" />
            Filtrar
          </button>
          <button
            @click="limpiarFiltros"
            class="px-6 py-3 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-200 font-medium flex items-center gap-2"
          >
            <Icon icon="mdi:refresh" class="text-lg" />
            Limpiar
          </button>
        </div>
      </div>
    </div>

    <!-- Tabla de Ventas -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden mb-6">
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 px-6 py-4 border-b border-gray-100 dark:border-gray-700">
        <div class="flex flex-wrap justify-between items-center gap-4">
          <h2 class="text-lg font-semibold text-gray-800 dark:text-white flex items-center">
            <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg mr-3">
              <Icon icon="mdi:format-list-bulleted" class="text-blue-600 dark:text-blue-400 text-xl" />
            </div>
            Listado de Ventas
            <span v-if="ventasFiltradas.length > 0" class="ml-2 text-sm bg-gray-200 dark:bg-gray-700 px-2 py-1 rounded-full">
              {{ ventasFiltradas.length }} registros
            </span>
          </h2>
          
          <div class="flex gap-2">
            <button
              @click="exportarExcel"
              :disabled="ventasFiltradas.length === 0"
              :class="[
                'px-4 py-2 rounded-xl transition-all duration-200 flex items-center gap-2 text-sm font-medium',
                ventasFiltradas.length > 0
                  ? 'bg-green-600 text-white hover:bg-green-700 shadow-md hover:shadow-lg'
                  : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
              ]"
            >
              <Icon icon="mdi:file-excel" class="text-lg" />
              Exportar Excel
            </button>
            <button
              @click="imprimirReporte"
              :disabled="ventasFiltradas.length === 0"
              :class="[
                'px-4 py-2 rounded-xl transition-all duration-200 flex items-center gap-2 text-sm font-medium',
                ventasFiltradas.length > 0
                  ? 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-md hover:shadow-lg'
                  : 'bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed'
              ]"
            >
              <Icon icon="mdi:printer" class="text-lg" />
              Imprimir Reporte
            </button>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div v-if="cargando" class="p-12 text-center">
        <div class="inline-block animate-spin rounded-full h-8 w-8 border-3 border-blue-500 border-t-transparent"></div>
        <p class="text-gray-500 dark:text-gray-400 mt-3">Cargando ventas...</p>
      </div>

      <!-- Tabla de datos -->
      <div v-else-if="ventasFiltradas.length > 0" class="overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-50 dark:bg-gray-700/50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Factura</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Fecha</th>
              <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Tipo</th>
              <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Total USD</th>
              <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Total Bs</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Método Pago</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Cliente</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Vendedor</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
            <tr v-for="venta in ventasFiltradas" :key="venta.idVenta" @click="verDetalles(venta)" class="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-150 cursor-pointer">
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                {{ venta.numeroFactura || '—' }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                {{ formatearFechaCorta(venta.fechaVenta) }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-center">
                <span :class="getBadgeTipoVenta(venta.tipoVenta).clase" class="inline-block px-3 py-1 text-xs font-semibold rounded-full">
                  {{ getBadgeTipoVenta(venta.tipoVenta).texto }}
                </span>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-right">
                <div class="text-sm font-bold text-gray-700 dark:text-gray-300">$ {{ (venta.totalUsd || 0).toFixed(2) }}</div>
                <div v-if="esVentaCredito(venta)" class="text-[10px] font-black uppercase tracking-tighter" :class="(venta.montoPagado || 0) > 0 ? 'text-green-600 dark:text-green-400' : 'text-gray-400 dark:text-gray-500'">
                  {{ (venta.montoPagado || 0) > 0 ? `Abonó: $${(venta.montoPagado).toFixed(2)}` : 'Sin abono' }}
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-bold text-green-600 dark:text-green-400">
                {{ formatearMonedaBs(venta.totalBs || 0) }}
              </td>
              <td class="px-6 py-4 text-xs font-bold text-gray-600 dark:text-gray-400">
                <span :class="venta.metodoPago?.includes('CRÉDITO') ? 'text-orange-600 dark:text-orange-400' : 'text-blue-600 dark:text-blue-400'">
                  {{ venta.metodoPago || '—' }}
                </span>
              </td>
              <td class="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                {{ venta.clienteNombre || 'Consumidor Final' }}
              </td>
              <td class="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                {{ venta.vendedorNombre || '—' }}
              </td>
            </tr>
          </tbody>
          <tfoot class="bg-gray-50 dark:bg-gray-700/50 font-bold border-t-2 border-gray-200 dark:border-gray-600">
            <tr class="h-8">
              <td colspan="3" class="px-6 py-1 text-right text-xs text-gray-500 uppercase whitespace-nowrap">
                Total Vendido:
              </td>
              <td class="px-6 py-1 text-right whitespace-nowrap text-sm text-gray-800 dark:text-white">
                ${{ estadisticasFiltradas.totalUSD.toFixed(2) }}
              </td>
              <td class="px-6 py-1 text-right whitespace-nowrap text-sm text-green-700 dark:text-green-400">
                {{ formatearMonedaBs(estadisticasFiltradas.totalFacturado) }}
              </td>
              <td colspan="4" class="px-6 py-1"></td>
            </tr>
            <tr class="bg-green-50 dark:bg-green-900/10 border-t border-green-100 dark:border-green-800 h-10">
              <td colspan="3" class="px-6 py-1 text-right text-xs text-green-700 dark:text-green-400 uppercase font-black whitespace-nowrap">
                TOTAL COBRADO (CAJA):
              </td>
              <td class="px-6 py-1 text-right whitespace-nowrap text-sm font-black text-green-600 dark:text-green-400 border-l border-green-100 dark:border-green-800">
                ${{ (estadisticasFiltradas.totalCobradoUSD || 0).toFixed(2) }}
              </td>
              <td class="px-6 py-1 text-right whitespace-nowrap text-xs font-bold text-green-700 dark:text-green-400">
                Bs.{{ (estadisticasFiltradas.totalCobradoUSD * (ventasFiltradas[0]?.totalBs / ventasFiltradas[0]?.totalUsd || 1)).toFixed(2) }}
              </td>
              <td colspan="3" class="px-6 py-1"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Empty state -->
      <div v-else class="text-center py-12">
        <div class="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
          <Icon icon="mdi:chart-line" class="text-4xl text-gray-400" />
        </div>
        <p class="text-gray-600 dark:text-gray-400 font-medium">No hay ventas para mostrar</p>
        <p class="text-sm text-gray-500 dark:text-gray-500 mt-1">Prueba cambiando los filtros</p>
      </div>
    </div>

    <!-- Tarjetas de Estadísticas -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-5 hover:shadow-xl transition-all duration-200">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500 dark:text-gray-400">Total Ventas</p>
            <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ estadisticasFiltradas.total }}</p>
          </div>
          <div class="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-xl">
            <Icon icon="mdi:cart" class="text-2xl text-blue-600 dark:text-blue-400" />
          </div>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-5 hover:shadow-xl transition-all duration-200">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500 dark:text-gray-400">Total Facturado (Bs)</p>
            <p class="text-2xl font-bold text-green-600 dark:text-green-400">{{ formatearMonedaBs(estadisticasFiltradas.totalFacturado) }}</p>
          </div>
          <div class="p-3 bg-green-100 dark:bg-green-900/30 rounded-xl">
            <Icon icon="mdi:cash" class="text-2xl text-green-600 dark:text-green-400" />
          </div>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-5 hover:shadow-xl transition-all duration-200">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500 dark:text-gray-400">Ventas Contado</p>
            <p class="text-2xl font-bold text-orange-600 dark:text-orange-400">{{ estadisticasFiltradas.ventasContado }}</p>
          </div>
          <div class="p-3 bg-orange-100 dark:bg-orange-900/30 rounded-xl">
            <Icon icon="mdi:cash-fast" class="text-2xl text-orange-600 dark:text-orange-400" />
          </div>
        </div>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 p-5 hover:shadow-xl transition-all duration-200">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-gray-500 dark:text-gray-400">Ventas Crédito</p>
            <p class="text-2xl font-bold text-purple-600 dark:text-purple-400">{{ estadisticasFiltradas.ventasCredito }}</p>
          </div>
          <div class="p-3 bg-purple-100 dark:bg-purple-900/30 rounded-xl">
            <Icon icon="mdi:credit-card" class="text-2xl text-purple-600 dark:text-purple-400" />
          </div>
        </div>
      </div>
    </div>

    <!-- Panel de Distribución de Ingresos por Método de Pago (Hoy) -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-4 mb-6 border border-gray-100 dark:border-gray-700">
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-200 flex items-center gap-2">
          <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
            <Icon icon="mdi:chart-pie" class="text-blue-600 dark:text-blue-400 text-xl" />
          </div>
          Distribución de Ingresos por Método de Pago y Créditos (Hoy)
        </h2>
        <div v-if="tasaUbcv" class="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-700 rounded-xl">
          <Icon icon="mdi:currency-usd" class="text-emerald-600 dark:text-emerald-400 text-sm" />
          <span class="text-xs font-bold text-emerald-700 dark:text-emerald-400">Tasa UBCV: Bs. {{ tasaUbcv.toFixed(2) }} por Dólar</span>
        </div>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div
          v-for="(val, metodo) in ingresosResumen"
          :key="metodo"
          class="p-4 rounded-2xl border-2 transition-all duration-200 hover:shadow-md"
          :class="getMetodoStyleVenta(metodo)"
        >
          <div class="flex justify-between items-center mb-3">
            <span class="font-bold text-sm" :title="metodo">{{ metodo }}</span>
            <div class="p-2 rounded-xl bg-white/50 dark:bg-black/20">
              <Icon :icon="getMetodoIconVenta(metodo)" class="text-xl" />
            </div>
          </div>
          <div class="space-y-1">
            <div class="flex justify-between items-center">
              <span class="text-xs font-medium opacity-80">USD</span>
              <span class="font-black text-base">${{ val.usd.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-xs font-medium opacity-80">Bs.</span>
              <span class="text-xs font-bold opacity-70">{{ tasaUbcv ? val.bs.toFixed(2) : '—' }}</span>
            </div>
          </div>
        </div>
        <div v-if="Object.keys(ingresosResumen).length === 0" class="col-span-full text-center py-8 text-gray-400 dark:text-gray-500">
          <Icon icon="mdi:chart-pie-outline" class="text-4xl mx-auto mb-2" />
          <p class="text-sm">No hay ingresos para los filtros seleccionados.</p>
        </div>
      </div>

      <!-- Totales rápidos -->
      <div v-if="Object.keys(ingresosResumen).length > 0" class="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700 flex flex-wrap gap-4 justify-end">
        <div class="flex items-center gap-2">
          <span class="text-xs font-bold text-gray-500 uppercase">Total USD:</span>
          <span class="text-sm font-black text-blue-600 dark:text-blue-400">
            ${{ Object.values(ingresosResumen).reduce((s, v) => s + v.usd, 0).toFixed(2) }}
          </span>
        </div>
        <div v-if="tasaUbcv" class="flex items-center gap-2">
          <span class="text-xs font-bold text-gray-500 uppercase">Total Bs.:</span>
          <span class="text-sm font-black text-emerald-600 dark:text-emerald-400">
            {{ Object.values(ingresosResumen).reduce((s, v) => s + v.bs, 0).toFixed(2) }}
          </span>
        </div>
      </div>
    </div>

    <!-- MODAL DE DETALLES -->
    <Teleport to="body">
      <div v-if="modalDetalles.show" class="fixed inset-0 z-50 overflow-hidden flex items-center justify-center p-2 sm:p-4" role="dialog">
        <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="cerrarModalDetalles"></div>
        <div class="relative bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-4xl flex flex-col overflow-hidden transform transition-all animate-fadeIn max-h-[90vh]">
          <!-- Header -->
          <div class="px-6 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="p-2 rounded-xl bg-white/20">
                <Icon icon="mdi:receipt-text" class="text-white text-xl" />
              </div>
              <div>
                <h3 class="text-base font-bold text-white uppercase tracking-wider">{{ ventaSeleccionada?.numeroFactura }}</h3>
                <p class="text-[10px] text-blue-100 uppercase font-medium">{{ formatFechaCompleta(ventaSeleccionada?.fechaVenta) }}</p>
              </div>
            </div>
            <button @click="cerrarModalDetalles" class="text-white/80 hover:text-white transition-colors">
              <Icon icon="mdi:close" class="text-xl" />
            </button>
          </div>

          <!-- Tabs -->
          <div class="flex bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700 p-1">
            <button v-for="tab in ['resumen', 'productos', 'pagos', 'observaciones']" :key="tab" @click="tabActiva = tab" :class="['flex-1 py-2 text-[10px] font-black uppercase rounded-lg transition-all', tabActiva === tab ? 'bg-white dark:bg-gray-700 text-blue-600 shadow-sm' : 'text-gray-400 hover:text-gray-600']">{{ tab }}</button>
          </div>

          <!-- Content -->
          <div class="flex-1 overflow-y-auto p-6">
            <div v-if="tabActiva === 'resumen'" class="space-y-4 animate-fadeIn">
              <div class="grid grid-cols-2 gap-4">
                <div class="p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                  <span class="text-[10px] font-bold text-gray-400 uppercase block mb-1">Cliente</span>
                  <span class="text-sm font-black text-gray-800 dark:text-white">{{ ventaSeleccionada?.clienteNombre }}</span>
                </div>
                <div class="p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700">
                  <span class="text-[10px] font-bold text-gray-400 uppercase block mb-1">Vendedor</span>
                  <span class="text-sm font-black text-gray-800 dark:text-white">{{ ventaSeleccionada?.vendedorNombre }}</span>
                </div>
              </div>
              <div class="grid grid-cols-4 gap-2">
                <div class="p-3 bg-blue-500/5 rounded-xl text-center">
                   <p class="text-[9px] font-bold text-blue-400 uppercase mb-1">Total USD</p>
                   <p class="text-sm font-black text-blue-600">${{ formatNumber(ventaSeleccionada?.totalUsd) }}</p>
                </div>
                <div class="p-3 bg-green-500/5 rounded-xl text-center">
                   <p class="text-[9px] font-bold text-green-400 uppercase mb-1">Estado</p>
                   <p class="text-[10px] font-black text-green-600 uppercase">{{ ventaSeleccionada?.estado }}</p>
                </div>
                <div class="p-3 bg-indigo-500/5 rounded-xl text-center col-span-2">
                   <p class="text-[9px] font-bold text-indigo-400 uppercase mb-1">Método</p>
                   <p class="text-[10px] font-black text-indigo-600 uppercase">{{ ventaSeleccionada?.metodoPago || 'Efectivo' }}</p>
                </div>
              </div>
            </div>

            <div v-if="tabActiva === 'productos'" class="space-y-2 animate-fadeIn">
              <div v-for="detalle in ventaSeleccionada?.detalles" :key="detalle.idVentaDetalle" class="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700">
                <div>
                  <p class="text-xs font-bold text-gray-800 dark:text-white uppercase">{{ detalle.nombreProducto || detalle.productoNombre }}</p>
                  <p class="text-[10px] text-gray-400 font-bold uppercase">{{ detalle.cantidad }} Uds x ${{ formatNumber(detalle.precioUnitarioUsd) }}</p>
                </div>
                <p class="text-sm font-black text-blue-600">${{ formatNumber(detalle.subtotalUsd) }}</p>
              </div>
            </div>

            <div v-if="tabActiva === 'pagos'" class="space-y-4 animate-fadeIn">
               <div v-if="ventaSeleccionada?.pagos?.length > 0">
                 <div v-for="(pago, i) in ventaSeleccionada.pagos" :key="i" class="p-4 rounded-2xl bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-sm">
                   <div class="flex justify-between items-center border-b border-gray-50 dark:border-gray-700 pb-2 mb-2">
                     <span class="text-[10px] font-black text-indigo-500 uppercase">Recibo #{{ i+1 }}</span>
                     <span class="text-[10px] font-bold text-gray-400">{{ formatFechaCompleta(pago.fechaPago) }}</span>
                   </div>
                   <div class="flex justify-between items-end">
                     <div>
                       <p class="text-[10px] font-bold text-gray-400 uppercase">Vía: {{ pago.tipoPago }}</p>
                     </div>
                     <p class="text-lg font-black text-green-600">${{ formatNumber(pago.montoUsd) }}</p>
                   </div>
                 </div>
               </div>
               <div v-else class="text-center py-10">
                 <Icon icon="mdi:cash-off" class="text-4xl text-gray-200 mx-auto mb-2" />
                 <p class="text-[10px] font-bold text-gray-400 uppercase">No se registran pagos directos</p>
               </div>
            </div>

             <div v-if="tabActiva === 'observaciones'" class="p-4 bg-gray-50 dark:bg-gray-800 rounded-2xl min-h-[100px] border border-gray-100 dark:border-gray-700 animate-fadeIn">
               <p class="text-xs text-gray-600 dark:text-gray-300">{{ ventaSeleccionada?.observaciones || 'Sin comentarios adicionales.' }}</p>
            </div>
          </div>

          <!-- Footer -->
          <div class="p-4 border-t border-gray-100 dark:border-gray-800 bg-gray-50/50 dark:bg-gray-800/50 flex justify-end gap-2">
            <button @click="cerrarModalDetalles" class="px-6 py-2 text-[10px] font-black text-gray-400 uppercase hover:text-gray-600">Cerrar Detalle</button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import { obtenerVentas, obtenerVentaConRelaciones } from '@/api/ventas.js';
import { obtenerPagosPorVenta } from '@/api/pagoVenta.js';
import { obtenerVendedores } from '@/api/vendedores.js';
import { obtenerClientes } from '@/api/clientes.js';
import { obtenerTasaVentaActual } from '@/api/tasaVenta.js';
import { 
  imprimirReporteVentas, 
  exportarVentasExcel, 
  formatearFechaCorta, 
  formatearMonedaBs, 
  getBadgeTipoVenta, 
  getBadgeEstadoVenta
} from '@/utils/reporteVentasGenerator.js';

export default {
  name: 'ReporteVentas',
  components: {
    Icon,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      cargando: false,
      ventas: [],
      ventasFiltradas: [],
      vendedores: [],
      clientes: [],
      // Mapas para nombres
      vendedoresMap: new Map(),
      clientesMap: new Map(),
      tasaUbcv: null,
      ingresosResumen: {},
      filtros: {
        tipoVenta: 'todos',
        estado: 'todos',
        idCliente: 'todos',
        idVendedor: 'todos',
        fechaDesde: new Date().toLocaleDateString('sv-SE'),
        fechaHasta: ''
      },
      estadisticasFiltradas: {
        total: 0,
        totalFacturado: 0,
        totalUSD: 0,
        ventasContado: 0,
        ventasCredito: 0,
        totalCobradoUSD: 0
      },
      // Modal state
      modalDetalles: { show: false },
      ventaSeleccionada: null,
      tabActiva: 'resumen'
    };
  },
  async mounted() {
    await this.cargarVendedores();
    await this.cargarClientes();
    await this.cargarTasaUbcv();
    await this.cargarVentas();
  },
  methods: {
    formatearFechaCorta,
    formatearMonedaBs,
    getBadgeTipoVenta,
    getBadgeEstadoVenta,

    async cargarTasaUbcv() {
      try {
        const res = await obtenerTasaVentaActual();
        if (res.success && res.data && res.data.precio_usd_bs) {
          this.tasaUbcv = parseFloat(res.data.precio_usd_bs);
        } else {
          this.tasaUbcv = null;
        }
      } catch (e) {
        console.error('Error cargando tasa UBCV en ventas', e);
        this.tasaUbcv = null;
      }
    },

    actualizarResumenVentas() {
      const resumen = {};
      this.ventasFiltradas.forEach(v => {
        // Determinar método de pago display
        let metodo = (v.metodoPago || 'EFECTIVO').toString().toUpperCase();
        if (metodo.includes('CRÉDITO') || metodo.includes('CREDITO')) {
          if (metodo.includes('CACHEA') || metodo.includes('CAS')) metodo = 'CRÉDITO (CACHEAS)';
          else if (metodo.includes('EMPRESA') || metodo.includes('CORP')) metodo = 'CRÉDITO (EMPRESA)';
          else metodo = 'CRÉDITO';
        } else if (metodo.includes('MOVIL') || metodo.includes('MÓVIL') || metodo.includes('PAGO M')) {
          metodo = 'PAGO MÓVIL';
        } else if (metodo.includes('TRANSFERENCIA')) {
          metodo = 'TRANSFERENCIA';
        } else if (metodo.includes('PUNTO')) {
          metodo = 'PUNTO DE VENTA';
        } else if (metodo.includes('EFECTIVO') || metodo.includes('CASH')) {
          metodo = 'EFECTIVO';
        }

        // Para crédito usamos sólo lo cobrado (montoPagado), para contado el total
        const usd = this.esVentaCredito(v)
          ? (parseFloat(v.montoPagado) || 0)
          : (parseFloat(v.totalUsd) || 0);
        const bs = this.tasaUbcv ? usd * this.tasaUbcv : 0;

        if (!resumen[metodo]) resumen[metodo] = { usd: 0, bs: 0 };
        resumen[metodo].usd += usd;
        resumen[metodo].bs += bs;
      });
      Object.values(resumen).forEach(val => {
        val.usd = parseFloat(val.usd.toFixed(2));
        val.bs = parseFloat(val.bs.toFixed(2));
      });
      this.ingresosResumen = resumen;
    },

    getMetodoStyleVenta(metodo) {
      const m = (metodo || '').toLowerCase();
      if (m.includes('cashea') || m.includes('cachea')) return 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-400';
      if (m.includes('movil') || m.includes('móvil') || m.includes('pago m')) return 'bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400';
      if (m.includes('transferencia')) return 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400';
      if (m.includes('punto')) return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
      if (m.includes('credito') || m.includes('crédito') || m.includes('empresa')) return 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400';
      if (m.includes('efectivo') || m.includes('cash')) return 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400';
      return 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300';
    },

    getMetodoIconVenta(metodo) {
      const m = (metodo || '').toLowerCase();
      if (m.includes('cashea') || m.includes('cachea')) return 'mdi:lightning-bolt';
      if (m.includes('movil') || m.includes('móvil') || m.includes('pago m')) return 'mdi:cellphone';
      if (m.includes('transferencia')) return 'mdi:bank-transfer';
      if (m.includes('punto')) return 'mdi:credit-card-outline';
      if (m.includes('credito') || m.includes('crédito') || m.includes('empresa')) return 'mdi:domain';
      if (m.includes('efectivo') || m.includes('cash')) return 'mdi:cash';
      return 'mdi:cash-multiple';
    },

    async cargarVendedores() {
      try {
        const response = await obtenerVendedores();
        if (response.success) {
          this.vendedores = (response.data || []).map(v => ({
            idVendedor: v.idVendedor,
            nombreCompleto: `${v.nombre} ${v.apellido || ''}`.trim()
          }));
          // Crear mapa para búsqueda rápida
          this.vendedores.forEach(v => {
            this.vendedoresMap.set(v.idVendedor, v.nombreCompleto);
          });
        }
      } catch (error) {
        console.error('Error cargando vendedores:', error);
      }
    },

    async cargarClientes() {
      try {
        const response = await obtenerClientes();
        if (response.success) {
          this.clientes = (response.data || []).map(c => ({
            idCliente: c.idCliente,
            nombreCompleto: `${c.nombre} ${c.apellido || ''}`.trim()
          }));
          // Crear mapa para búsqueda rápida
          this.clientes.forEach(c => {
            this.clientesMap.set(c.idCliente, c.nombreCompleto);
          });
        }
      } catch (error) {
        console.error('Error cargando clientes:', error);
      }
    },

    // Normalizar venta desde la API
    normalizarVenta(venta) {
      const vendedorNombre = this.vendedoresMap.get(venta.idVendedor) || `Vendedor ${venta.idVendedor}`;
      const clienteNombre = this.clientesMap.get(venta.idCliente) || `Cliente ${venta.idCliente}`;
      
      return {
        idVenta: venta.idVenta,
        numeroFactura: venta.numeroFactura,
        fechaVenta: venta.fechaVenta,
        tipoVenta: (venta.tipoVenta || '').toString(),
        idTipoCredito: venta.idTipoCredito || venta.id_tipo_credito || venta.tipo_credito_id,
        totalUsd: venta.totalUsd || 0,
        totalBs: venta.totalBs || 0,
        estado: venta.estado,
        idCliente: venta.idCliente,
        clienteNombre: clienteNombre,
        idVendedor: venta.idVendedor,
        vendedorNombre: vendedorNombre,
        metodoPago: '—'
      };
    },

    async cargarVentas() {
      this.cargando = true;
      try {
        const response = await obtenerVentas();
        if (response.success) {
          // Normalizar las ventas
          this.ventas = (response.data || []).map(v => this.normalizarVenta(v));
          this.aplicarFiltros();
          
          // Cargar métodos de pago de forma asíncrona
          this.cargarMetodosPago();
        } else {
          this.toast.error('Error al cargar las ventas');
        }
      } catch (error) {
        console.error('Error cargando ventas:', error);
        this.toast.error('Error al cargar las ventas');
      } finally {
        this.cargando = false;
      }
    },

    async cargarMetodosPago() {
      // Usamos Promise.all para cargar más rápido
      await Promise.all(this.ventas.map(async (venta) => {
        try {
          const vTipo = (venta.tipoVenta || '').toUpperCase();
          const resPagos = await obtenerPagosPorVenta(venta.idVenta);
          let pagosData = (resPagos.success && resPagos.data) ? resPagos.data : [];
          
          if (vTipo.includes('CREDITO') || vTipo.includes('CRÉDITO')) {
            const idC = (venta.idTipoCredito || '').toString().toUpperCase();
            let label = '';
            if (idC.includes('CAS') || idC.includes('CACHEA')) label = 'CACHEAS';
            else if (idC.includes('EMP') || idC.includes('CORP')) label = 'EMPRESA';
            else label = 'CRÉDITO';
            
            venta.tipoVenta = 'CRÉDITO';

            if (pagosData.length > 0) {
              const p = pagosData[0]; // Primer pago (el inicial)
              const mp = (p.tipoPago || p.metodo_pago || 'efectivo').toLowerCase();
              venta.metodoPago = `${label} + ${mp}`;
            } else {
              venta.metodoPago = label;
            }
          } else {
            if (pagosData.length > 0) {
              const p = pagosData[pagosData.length - 1]; // Último pago para contado
              venta.metodoPago = (p.tipoPago || p.metodo_pago || 'efectivo').toLowerCase();
            } else {
              venta.metodoPago = 'efectivo';
            }
          }
          venta.montoPagado = pagosData.reduce((sum, p) => sum + (parseFloat(p.montoUsd || p.monto_usd) || 0), 0);
        } catch (err) {
          venta.metodoPago = '—';
          venta.montoPagado = 0;
        }
      }));
      this.calcularEstadisticasFiltradas();
      this.actualizarResumenVentas();
    },

    aplicarFiltros() {
      console.log('=== APLICANDO FILTROS ===');
      console.log('Filtros:', this.filtros);
      
      let ventasFiltradas = [...this.ventas];

      // Filtrar por tipo de venta
      if (this.filtros.tipoVenta !== 'todos') {
        ventasFiltradas = ventasFiltradas.filter(v => {
          if (this.filtros.tipoVenta === 'contado') {
            return !this.esVentaCredito(v);
          } else {
            return this.esVentaCredito(v);
          }
        });
        console.log('Después filtro tipo venta:', ventasFiltradas.length);
      }

      // Filtrar por estado
      if (this.filtros.estado !== 'todos') {
        ventasFiltradas = ventasFiltradas.filter(v => {
          const estado = v.estado || '';
          return estado === this.filtros.estado;
        });
        console.log('Después filtro estado:', ventasFiltradas.length);
      }

      // Filtrar por cliente
      if (this.filtros.idCliente !== 'todos') {
        ventasFiltradas = ventasFiltradas.filter(v => 
          v.idCliente == this.filtros.idCliente
        );
        console.log('Después filtro cliente:', ventasFiltradas.length);
      }

      // Filtrar por vendedor
      if (this.filtros.idVendedor !== 'todos') {
        ventasFiltradas = ventasFiltradas.filter(v => 
          v.idVendedor == this.filtros.idVendedor
        );
        console.log('Después filtro vendedor:', ventasFiltradas.length);
      }

      const fdStr = this.filtros.fechaDesde;
      const fhStr = this.filtros.fechaHasta;

      if (fdStr && !fhStr) {
        // Solo fecha inicial: mostrar SOLO ese día
        ventasFiltradas = ventasFiltradas.filter(v => {
          const match = String(v.fechaVenta || '').match(/^(\d{4}-\d{2}-\d{2})/);
          const fv = match ? match[1] : '';
          return fv === fdStr;
        });
      } else {
        if (fdStr) {
          ventasFiltradas = ventasFiltradas.filter(v => {
            const match = String(v.fechaVenta || '').match(/^(\d{4}-\d{2}-\d{2})/);
            const fv = match ? match[1] : '';
            return fv >= fdStr;
          });
        }
        if (fhStr) {
          ventasFiltradas = ventasFiltradas.filter(v => {
            const match = String(v.fechaVenta || '').match(/^(\d{4}-\d{2}-\d{2})/);
            const fv = match ? match[1] : '';
            return fv <= fhStr;
          });
        }
      }

      this.ventasFiltradas = ventasFiltradas;
      this.calcularEstadisticasFiltradas();
      this.actualizarResumenVentas();
      
      console.log('Total ventas filtradas:', this.ventasFiltradas.length);
    },

    calcularEstadisticasFiltradas() {
      const total = this.ventasFiltradas.length;
      
      const ventasContado = this.ventasFiltradas.filter(v => 
        !this.esVentaCredito(v)
      ).length;
      
      const ventasCredito = this.ventasFiltradas.filter(v => 
        this.esVentaCredito(v)
      ).length;
      
      const totalFacturado = this.ventasFiltradas.reduce((sum, v) => sum + (v.totalBs || 0), 0);
      const totalUSD = this.ventasFiltradas.reduce((sum, v) => sum + (v.totalUsd || 0), 0);
      
      // TOTAL REAL COBRADO PARA CAJA:
      // - Ventas CONTADO: suma el total completo (se pagó todo)
      // - Ventas CRÉDITO: suma solo lo abonado (montoPagado)
      // - Crédito empresa sin abono: $0 (no entró dinero a la caja)
      const totalCobradoUSD = this.ventasFiltradas.reduce((sum, v) => {
        if (this.esVentaCredito(v)) {
          // Para crédito: solo lo que realmente se abonó
          return sum + (parseFloat(v.montoPagado) || 0);
        } else {
          // Para contado: el total completo
          return sum + (v.totalUsd || 0);
        }
      }, 0);
      
      this.estadisticasFiltradas = {
        total,
        totalFacturado,
        totalUSD,
        ventasContado,
        ventasCredito,
        totalCobradoUSD
      };
    },

    // Determinar si una venta es a crédito
    esVentaCredito(venta) {
      const tipo = (venta.tipoVenta || '').toLowerCase();
      return tipo.includes('credito') || tipo.includes('crédito');
    },

    limpiarFiltros() {
      const today = new Date().toLocaleDateString('sv-SE');
      this.filtros = {
        tipoVenta: 'todos',
        estado: 'todos',
        idCliente: 'todos',
        idVendedor: 'todos',
        fechaDesde: today,
        fechaHasta: ''
      };
      this.aplicarFiltros();
      this.toast.info('Filtros limpiados');
    },

    async exportarExcel() {
      if (this.ventasFiltradas.length === 0) {
        this.toast.warning('No hay ventas para exportar');
        return;
      }

      try {
        const titulo = this.obtenerTituloReporte();
        const result = exportarVentasExcel(this.ventasFiltradas, titulo);
        if (result.success) {
          this.toast.success(`Exportadas ${result.count} ventas a Excel`);
        } else {
          throw new Error(result.error);
        }
      } catch (error) {
        console.error('Error exportando:', error);
        this.toast.error('Error al exportar a Excel');
      }
    },

    async imprimirReporte() {
      if (this.ventasFiltradas.length === 0) {
        this.toast.warning('No hay ventas para imprimir');
        return;
      }

      try {
        const titulo = this.obtenerTituloReporte();
        // Pre-formatear para que el generador no recalculé mal
        const ventasParaReporte = this.ventasFiltradas.map(v => ({
          ...v,
          // Si es crédito, asegurar que el tipoVenta tenga el detalle para el PDF
          tipoVenta: v.metodoPago?.includes('CRÉDITO') ? v.metodoPago : v.tipoVenta
        }));
        await imprimirReporteVentas(ventasParaReporte, titulo);
      } catch (error) {
        console.error('Error imprimiendo:', error);
        this.toast.error('Error al imprimir el reporte');
      }
    },

    obtenerTituloReporte() {
      let titulo = 'REPORTE DE VENTAS';
      const partes = [];
      
      if (this.filtros.tipoVenta !== 'todos') {
        partes.push(this.filtros.tipoVenta === 'contado' ? 'CONTADO' : 'CRÉDITO');
      }
      
      if (this.filtros.estado !== 'todos') {
        let estadoTexto = this.filtros.estado.toUpperCase();
        if (estadoTexto === 'COMPLETADA') estadoTexto = 'PAGADAS';
        partes.push(estadoTexto);
      }
      
      if (this.filtros.idCliente !== 'todos') {
        const cliente = this.clientes.find(c => c.idCliente == this.filtros.idCliente);
        if (cliente) {
          partes.push(`CLIENTE: ${cliente.nombreCompleto}`);
        }
      }
      
      if (this.filtros.idVendedor !== 'todos') {
        const vendedor = this.vendedores.find(v => v.idVendedor == this.filtros.idVendedor);
        if (vendedor) {
          partes.push(`VENDEDOR: ${vendedor.nombreCompleto}`);
        }
      }
      
      if (this.filtros.fechaDesde || this.filtros.fechaHasta) {
        const desde = this.filtros.fechaDesde || 'INICIO';
        const hasta = this.filtros.fechaHasta || 'HOY';
        partes.push(`${desde} al ${hasta}`);
      }
      
      if (partes.length > 0) {
        titulo += ` - ${partes.join(' - ')}`;
      }
      
      return titulo;
    },

    volver() {
      this.$router.push('/dashboard');
    },

    // Métodos para el Modal de Detalles
    async verDetalles(v) {
      this.ventaSeleccionada = { ...v };
      await this.cargarDetallesVenta(this.ventaSeleccionada);
      this.tabActiva = 'resumen';
      this.modalDetalles.show = true;
    },
    cerrarModalDetalles() { 
      this.modalDetalles.show = false; 
      setTimeout(() => { this.ventaSeleccionada = null; }, 300); 
    },
    async cargarDetallesVenta(venta) {
      try {
        const res = await obtenerVentaConRelaciones(venta.idVenta);
        if (res.success && res.data) {
          venta.detalles = res.data.detalles || [];
          // Asegurarnos de tener los pagos de la venta si se necesitan
          if (!venta.pagos && res.data.pagos) {
             venta.pagos = res.data.pagos;
          }
          venta.observaciones = res.data.observaciones;
          return true;
        }
        return false;
      } catch (e) {
        console.error('Error cargando detalles:', e);
        return false;
      }
    },
    formatFechaCompleta(fecha) {
      if (!fecha) return '—';
      return new Date(fecha).toLocaleDateString('es-ES', { 
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' 
      });
    },
    formatNumber(v) { 
      return v === null || v === undefined ? '0.00' : parseFloat(v).toFixed(2); 
    }
  }
};
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Badges de estado */
.estado-pagada {
  background: #dcfce7;
  color: #166534;
}
.dark .estado-pagada {
  background: #14532d;
  color: #86efac;
}
.estado-pendiente {
  background: #fef9c3;
  color: #854d0e;
}
.dark .estado-pendiente {
  background: #713f12;
  color: #fde047;
}
.estado-cancelada {
  background: #fee2e2;
  color: #991b1b;
}
.dark .estado-cancelada {
  background: #7f1a1a;
  color: #fecaca;
}
.estado-activa {
  background: #dbeafe;
  color: #1e40af;
}
.dark .estado-activa {
  background: #1e3a8a;
  color: #93c5fd;
}

/* Badges de tipo */
.tipo-contado {
  background: #e8f5e9;
  color: #2e7d32;
}
.dark .tipo-contado {
  background: #1b5e20;
  color: #a5d6a7;
}
.tipo-credito {
  background: #fff3e0;
  color: #ed6c02;
}
.dark .tipo-credito {
  background: #b76e0e;
  color: #ffb74d;
}
</style>
